import Breadcrumb from "components/Common/Breadcrumb"
import React, { useEffect, useState } from "react"
import {
  FaChevronLeft,
  FaChevronRight,
  FaPen,
  FaPlus,
  FaTrash,
} from "react-icons/fa6"
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Row,
  Table,
  Badge,
} from "reactstrap"
import moment from "moment"
import { Switch } from "antd"
import Swal from "sweetalert2"
import AddEditUserPlanModal from "./PlanModal"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"
import Loader from "components/Loader/loader"

const UserPlanIndex = () => {
  const [plans, setPlans] = useState([])
  const [data, setData] = useState([])
  const [page, setPage] = useState(1)
  const [itemsPerPage] = useState(10)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingPlan, setEditingPlan] = useState(null)

  const [loading, setloading] = useState(false)

  const [searchString, setSearchString] = useState("")

  useEffect(() => {
    if (searchString !== "") {
      const filteredData = data.filter(
        item =>
          item.planName.toLowerCase().includes(searchString.toLowerCase()) ||
          String(item.planPrice)
            .toLowerCase()
            .includes(searchString.toLowerCase())
      )
      setPlans(filteredData)
      setPage(1)
    } else {
      setPlans(data)
    }
  }, [searchString, data])

  const totalPages = Math.ceil(plans.length / itemsPerPage)
  const finalData = plans.slice((page - 1) * itemsPerPage, page * itemsPerPage)

  const changePage = pageNumber => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setPage(pageNumber)
      window.scrollTo(0, 0)
    }
  }

  useEffect(() => {
    getPlanData()
  }, [])

  async function getPlanData() {
    const APIdata = await fetchData(setloading, "pricing/plan")
    if (APIdata?.success) {
      setPlans(APIdata?.userPlans)
      setData(APIdata?.userPlans)
    }
  }

  const handleSave = async (entry, isEdit, editid) => {
    if (isEdit) {
      const APIData = await FetchPutData(
        setloading,
        "pricing/plan",
        editid,
        entry
      )

      if (APIData?.data?.success) {
        Swal.fire({
          title: "Plan Updated Successfully",
          icon: "success",
        })
        getPlanData()
      } else {
        Swal.fire({
          title: "Something went wrong",
          icon: "error",
          description: APIData?.response?.data?.message,
        })
      }
    } else {
      const APIData = await FetchPostData(setloading, "pricing/plan", entry)

      if (APIData?.data?.success) {
        Swal.fire({
          title: "Plan Added Successfully",
          icon: "success",
        })
        getPlanData()
      } else {
        Swal.fire({
          title: "Something went wrong",
          icon: "error",
          description: APIData?.response?.data?.message,
        })
      }
    }
  }

  const handleDelete = userId => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete this Plan",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async result => {
      if (result.isConfirmed) {
        const APIData = await FetchDeleteData(
          setloading,
          "pricing/plan",
          userId
        )

        if (APIData?.data?.success) {
          Swal.fire({
            title: "Plan Deleted Successfully",
            icon: "success",
          })
          getPlanData()
        } else {
          Swal.fire({
            title: "Something went wrong",
            icon: "error",
            description: APIData?.response?.data?.message,
          })
        }
      }
    })
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Container fluid>
        <Breadcrumb title="" breadcrumbItem="User Plans" />

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="text-black fw-bold ps-1 mb-0">User Plans</h4>
                  <div className="d-flex gap-3">
                    <div className="form-group">
                      <Input
                        placeholder="Search User Plans"
                        value={searchString}
                        onChange={e => setSearchString(e.target.value)}
                      />
                    </div>
                    <button
                      className="btn btn-add"
                      onClick={() => {
                        setEditingPlan(null)
                        setIsModalOpen(true)
                      }}
                      disabled={plans.length >= 2}
                    >
                      <FaPlus className="me-1" size={14} />
                      Add User Plan
                    </button>
                  </div>
                </div>

                <div className="mt-3">
                  <Table responsive bordered className="rounded-3">
                    <thead className="table-primary text-dark">
                      <tr>
                        <th>Sr No.</th>
                        <th>Plan Name</th>
                        <th>Price (£)</th>
                        <th>Plan Details</th>
                        <th>Screens</th>
                        <th>Created At</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {finalData.map((plan, index) => (
                        <tr key={plan.id}>
                          <td>{(page - 1) * itemsPerPage + index + 1}</td>
                          <td>{plan?.planName}</td>
                          <td>£ {plan?.planPrice.toFixed(2)}</td>
                          <td style={{ maxWidth: "300px" }}>
                            {plan?.planPrice > 0 ? (
                              <ul className="mb-0">
                                <li className="mb-0">
                                  Audio training instructions included.
                                </li>
                                <li className="mb-0">
                                  Flexible training days (can move workouts).
                                </li>
                                {/* <li className="mb-0">
                                  Calendar sync with personal calendar
                                  (Google/Outlook).
                                </li> */}
                                <li>Can renew 10-week plan and repeat it.</li>
                              </ul>
                            ) : (
                              <ul className="mb-0">
                                <li className="mb-0">No audio instructions.</li>
                                <li className="mb-0">
                                  Fixed training days (no flexibility).
                                </li>
                                {/* <li className="mb-0">
                                  No personal calendar sync.
                                </li> */}
                                <li>
                                  Training plan is downloadable once only.
                                </li>
                              </ul>
                            )}
                          </td>
                          <td style={{ maxWidth: "200px" }}>
                            {plan?.features.map((f, i) => (
                              <Badge
                                color="info"
                                className="me-1 mb-1 p-2"
                                key={i}
                                style={{ fontSize: "12px" }}
                              >
                                {f}
                              </Badge>
                            ))}
                          </td>
                          <td>
                            {moment(plan?.createdAt).format("DD-MM-YYYY")}
                          </td>
                          <td>
                            <button
                              className="btn btn-sm btn-primary me-2"
                              onClick={() => {
                                setEditingPlan(plan)
                                setIsModalOpen(true)
                              }}
                            >
                              <FaPen size={12} />
                            </button>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => handleDelete(plan?._id)}
                            >
                              <FaTrash size={12} />
                            </button>
                          </td>
                        </tr>
                      ))}
                      {finalData.length === 0 && (
                        <tr>
                          <td colSpan={7} className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                <div className="d-flex justify-content-between align-items-center my-2 px-2">
                  <p className="mb-0">
                    Showing {finalData.length} out of {plans.length} Plans.
                  </p>
                  <div className="d-flex flex-wrap">
                    <div
                      className="bd-number-pagination me-1"
                      onClick={() => changePage(page - 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronLeft />
                    </div>
                    {[...Array(totalPages)].map((_, i) => {
                      const pageIndex = i + 1
                      return (
                        <div
                          key={pageIndex}
                          className={`bd-number-pagination me-1 ${
                            page === pageIndex ? "activepage" : ""
                          }`}
                          onClick={() => changePage(pageIndex)}
                          style={{ cursor: "pointer" }}
                        >
                          {pageIndex < 10 ? "0" + pageIndex : pageIndex}
                        </div>
                      )
                    })}
                    <div
                      className="bd-number-pagination"
                      onClick={() => changePage(page + 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronRight />
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Add/Edit Modal */}
      <AddEditUserPlanModal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(!isModalOpen)}
        onSave={handleSave}
        editingPlan={editingPlan}
      />
    </div>
  )
}

export default UserPlanIndex
